import React, { useState, useEffect, useRef, useCallback } from "react";
import { Home, Pencil } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { apiUrl, assetsUrl } from "../config/Config";
import { useTranslation } from "react-i18next";
import Editor from "../components/Editor";
import kidsBannerImg from "../assets/images/new-home-page-img.png";
import Cropper from "react-easy-crop";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash, faEye,faPlus } from "@fortawesome/free-solid-svg-icons";
import SpeechRecognition, {
  useSpeechRecognition
} from "react-speech-recognition";
const EditStory = () => {
  const FIXED_ASPECT = 638 / 380;

  const { slug } = useParams();
  const customerdata = useSelector((store) => store.userReducer.customerdata);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const [format, setFormat] = useState("write");
  const [storyText, setStoryText] = useState("");
  const [title, setTitle] = useState("");
  const [name, setName] = useState("");
  const [language, setLanguage] = useState("en");
  const [photos, setPhotos] = useState([]);
  const [existingPhotos, setExistingPhotos] = useState([]);
  const [audioUrl, setAudioUrl] = useState(null);
  const [recording, setRecording] = useState(false);
  const [islistening, setisListening] = useState(false);
  const [editorLoaded, setEditorLoaded] = useState(true);
  const [selecteddiety, setselecteddiety] = useState("");
  const [selectedfestival, setselectedfestival] = useState("");
  const [selectedplace, setselectedplace] = useState("");
  const [storyid, setstoryid] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");
  const [storyCategory, setStoryCategory] = useState("adults");
  const [hideName, setHideName] = useState(false);

  const mediaRecorderRef = useRef(null);
  const chunksRef = useRef([]);
  const fileInputRef = useRef(null);
  const recognitionRef = useRef(null);






  const [cropModalOpen, setCropModalOpen] = useState(false);
const [selectedImage, setSelectedImage] = useState(null);
const [crop, setCrop] = useState({ x: 0, y: 0 });
const [zoom, setZoom] = useState(1);
const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const [errortitlemessage, seterrortitlemessage] = useState("");
  const [errornamemessage, seterrornamemessage] = useState("");
  const [errorstorytext, seterrorstorytext] = useState("");
  const [errorstoryaudio, seterrorstoryaudio] = useState("");













  const handleLanguageChange = (e) => {
    i18n.changeLanguage(e.target.value);
    setLanguage(e.target.value);
  };

  const baseTextRef = useRef("");
  const accumulatedTranscriptRef = useRef("");
  const {transcript,listening, resetTranscript, browserSupportsSpeechRecognition } = useSpeechRecognition();

  const startspeechtotext = () => {
    // baseTextRef.current = storyText; // store existing text    
    // resetTranscript(); // clear previous transcript

    // SpeechRecognition.startListening({ continuous: true, language: "en-IN" });
    // setisListening(true);


    if (listening) return; // prevent multiple starts

    baseTextRef.current = storyText;

    resetTranscript();

    SpeechRecognition.startListening({
      continuous: true,
      language: "en-IN",
    });
    setisListening(true);
  };

  const stoospeechtotext = () => {
    SpeechRecognition.stopListening();
    setisListening(false);
  };

  const startRecording = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    mediaRecorderRef.current = new MediaRecorder(stream);

    mediaRecorderRef.current.ondataavailable = (e) =>
      chunksRef.current.push(e.data);

    mediaRecorderRef.current.onstop = () => {
      const blob = new Blob(chunksRef.current, { type: "audio/webm" });
      setAudioUrl(URL.createObjectURL(blob));
      chunksRef.current = [];
    };

    mediaRecorderRef.current.start();
    setRecording(true);
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current?.state !== "inactive") {
      mediaRecorderRef.current.stop();
    }
    setRecording(false);
  };

  const handlePhotoUpload = (e) => {
  const file = e.target.files[0];

  if (file) {
    const imageUrl = URL.createObjectURL(file);
    setSelectedImage(imageUrl);
    setCropModalOpen(true);
  }

  e.target.value = "";
};

  const handleDragOver = (e) => e.preventDefault();


 const handleDrop = (e) => {
  e.preventDefault();
  const file = e.dataTransfer.files[0];

  if (file) {
    const imageUrl = URL.createObjectURL(file);
    setSelectedImage(imageUrl);
    setCropModalOpen(true);
  }
};

const onCropComplete = (croppedArea, croppedAreaPixels) => {
  setCroppedAreaPixels(croppedAreaPixels);
};






const createCroppedImage = async () => {
  const image = new Image();
  image.src = selectedImage;

  await new Promise((resolve) => {
    image.onload = resolve;
  });

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  canvas.width = 638;
  canvas.height = 380;

  ctx.drawImage(
    image,
    croppedAreaPixels.x,
    croppedAreaPixels.y,
    croppedAreaPixels.width,
    croppedAreaPixels.height,
    0,
    0,
    638,
    380
  );

  const blob = await new Promise((resolve) =>
    canvas.toBlob(resolve, "image/jpeg", 0.95)
  );

  const file = new File([blob], "story-image.jpg", {
    type: "image/jpeg",
  });

  setPhotos([file]);

  setCropModalOpen(false);
};



  const fetchStoryDetails = useCallback(async (slugtitle, signal) => {
    setLoading(true);
    setLoadError("");
    setstoryid("");
    try {
      const res = await axios.post(
        apiUrl + "getstorydetails",
        { slug: slugtitle, edit: true },
        {
          signal,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + customerdata?.token,
          },
        }
      );

      if (res.data.status === "success" && res.data.data?.id) {
        const s = res.data.data || {};

        setFormat(s.storytype === "textbased" ? "write" : "record");
        setStoryCategory(s.type || "adults");
        setstoryid(s.id);
        setLanguage(s.language || "en");
        setTitle(s.title || "");
        setName(s.type === "kids" ? (s.author_name || s.author || "") : (s.author || ""));
        setStoryText(s.storyText || "");
        setselecteddiety(s.deity || "");
        setselectedfestival(s.festival || "");
        setselectedplace(s.place || "");
        setHideName(s.hide_author == "true" ? true : false);

        setAudioUrl(s.audio ? assetsUrl + "audio/" + s.audio : null);

        try {
          const savedPhotos = JSON.parse(s.photos || "[]");
          setExistingPhotos(Array.isArray(savedPhotos) ? savedPhotos.slice(-1) : []);
        } catch {
          setExistingPhotos([]);
        }
      } else {
        setLoadError(res.data.message || "Unable to load this story.");
      }
    } catch (err) {
      if (signal.aborted) return;
      setLoadError(err.response?.data?.message || "Unable to load this story. Please try again.");
      if (err.response?.status === 401) {
        dispatch({ type: "customerdata", payload: {} });
        navigate("/login", { replace: true });
      }
    } finally {
      if (!signal.aborted) setLoading(false);
    }
  }, [customerdata?.token, dispatch, navigate]);

  const handleUpdate = async (e) => {
    e.preventDefault();

    var istitleerror = false;
    var isnameerror = false;
    var isstorytexterror = false;
    var isstoryaudioerror = false;

    if(title) {
      seterrortitlemessage("");
      istitleerror = false;
    } else {
      seterrortitlemessage("Title of the story cannot be empty.");
      istitleerror = true;
    }

    if (storyCategory === "kids" && !name.trim()) {
      seterrornamemessage("Name cannot be empty.");
      isnameerror = true;
    } else {
      seterrornamemessage("");
    }

    if(storyCategory === "kids" || format === "write") {
      seterrorstoryaudio("");
      isstoryaudioerror = false;
      if(storyText) {
        seterrorstorytext("")
        isstorytexterror = false;
      } else {
        seterrorstorytext("Story text is mandatory.")
        isstorytexterror = true;
      }
    } else {
      seterrorstorytext("")
      isstorytexterror = false;
      if(audioUrl) {
        seterrorstoryaudio("")
        isstoryaudioerror = false;
      } else {
        seterrorstoryaudio("Audio story is mandatory.")
        isstoryaudioerror = true;
      }
    }

    if(!istitleerror && !isnameerror && !isstorytexterror && !isstoryaudioerror) {
    } else {
      return;
    }

    const formData = new FormData();
    formData.append("storyid", storyid);
    formData.append("slug", slug);
    formData.append("type", storyCategory);
    formData.append("storytype", storyCategory === "kids" || format === "write" ? "textbased" : "audiobased");
    formData.append("language", language);
    formData.append("title", title);
    formData.append("name", name.trim());
    formData.append("storyText", storyText);
    formData.append("deity", selecteddiety);
    formData.append("festival", selectedfestival);
    formData.append("place", selectedplace);
    formData.append("hide_author", storyCategory === "kids" ? "false" : (hideName == true ? "true" : "false"));

    existingPhotos.forEach((p) => formData.append("existing_photos[]", p));

    photos.forEach((f) => formData.append("photos[]", f));

    // if (audioUrl?.startsWith("blob:")) {
    //   const blob = await fetch(audioUrl).then((r) => r.blob());
    //   formData.append("audio", new File([blob], "recording.webm", { type: blob.type }));
    // }

    var data = {
      storyid: storyid,
      slug: slug,
      format: format,
      language: language,
      title: title,
      storyText: storyText,
      selecteddiety: selecteddiety,
      selectedfestival: selectedfestival,
      selectedplace: selectedplace,
      photos: photos
    }

    if(audioUrl?.startsWith("blob:")) {
      const blob = await fetch(audioUrl).then(r => r.blob());
      // Wrap into a File (optional but cleaner)
      const file = new File([blob], "recording.webm", { type: blob.type });
      console.log('file >>', file);
      formData.append("audio", file);
      data['audio'] = file;
    } else {
      data['audio'] = null;
    }

    

    console.log('data >>', data);

    // console.log('formData >>', formData);

    try {
      const res = await axios.post(apiUrl + "updatestory", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + customerdata?.token,
        },
      });
      if (res.data.status === "success") navigate("/story/" + slug);
      else alert(res.data.message || "Update failed.");
    } catch (err) {
      console.error(err);
    }
  };

  const handleremoveimage = async(index) => {
    var previmages = existingPhotos;
    var newaarr = previmages.filter((_, i) => i !== index);
    console.log('newaarr >>', newaarr);
    var data = {
      id: storyid,
      images: newaarr?.length > 0 ? newaarr : null
    }
    try {
      const res = await axios.post(apiUrl + "removeimage", data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + customerdata?.token,
        },
      });
      if (res.data.status === "success") {
        // navigate("/story/" + slug)
        setExistingPhotos(existingPhotos.filter((_, i) => i !== index));
      }
      else alert(res.data.message || "Update failed.");
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    if (!slug || !customerdata?.token || customerdata.payment_status !== "completed") return;
    const controller = new AbortController();
    fetchStoryDetails(slug, controller.signal);
    return () => controller.abort();
  }, [slug, customerdata?.token, customerdata?.payment_status, fetchStoryDetails]);

  useEffect(() => {
    if (!customerdata?.token) {
      navigate("/login");
    } else if (customerdata.payment_status !== "completed") {
      alert("Please complete payment before editing a story");
      navigate("/");
    }
  }, [customerdata, navigate]);

  useEffect(() => {
      if (listening) {
        setStoryText(baseTextRef.current + transcript);
      }
    }, [transcript, listening]);

  if (loading) {
    return <div className="text-center py-5">Loading story...</div>;
  }

  if (loadError || !storyid) {
    return (
      <div className="text-center py-5" role="alert">
        <p>{loadError || "Unable to load this story."}</p>
        <button type="button" onClick={() => navigate("/allstory")}>Back to my stories</button>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        {/* Meta Title */}
        <title>Edit Your Story | THEOMSAGA</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Create and edit your spiritual stories on TheOmSaga. Update your content and share your journey seamlessly."
        />

        {/* NOINDEX for SEO safety */}
        <meta name="robots" content="noindex, nofollow" />

        {/* Canonical */}
        <link rel="canonical" href="https://theomsaga.com/edit" />

        {/* Open Graph Tags */}
        <meta property="og:title" content="Edit Your Story | THEOMSAGA" />
        <meta
          property="og:description"
          content="Refine and update your stories on THEOMSAGA."
        />
        <meta property="og:url" content="https://theomsaga.com/edit" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://theomsaga.com/assets/images/edit-story-banner.webp"
        />

        {/* Schema Markup */}
        <script type="application/ld+json">
          {`
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": "https://theomsaga.com/edit#webpage",
      "name": "Edit Your Story",
      "url": "https://theomsaga.com/editstory",
      "description": "Edit and update your spiritual stories on TheOmSaga platform.",

        "sameAs": [
                  "https://www.instagram.com/theomsaga20?igsh=MWNnN3E0NGVleTltZw==",
                  "https://www.facebook.com/share/1B44vEtGc7/"
                ]
      "isPartOf": {
        "@type": "WebSite",
        "name": "TheOmSaga",
        "url": "https://theomsaga.com"
      }
    }
    `}
        </script>
      </Helmet>

      <div className={storyCategory === "kids" ? "kids-story-page" : ""}>
        {storyCategory === "kids" ? (
          <section className="home-main-sec kids-story-banner">
            <img
              src={kidsBannerImg}
              className="home-main-sec-bg"
              alt="Kids Story Banner"
            />
            <div className="home-main-sec-overlay"></div>
            <div className="container home-main-sec-content">
              <h1 className="loop-title">Edit Your Motivational Story</h1>
            </div>
          </section>
        ) : (
          <section className="home-main-section story-bannar-img">
            <div className="container text-center"></div>
          </section>
        )}

        <div className={storyCategory === "kids" ? "kids-form-wrapper" : ""}>
        <div className="create-story-container">
          <h2 className="create-story-header">
            {storyCategory === "kids"
              ? "🧒 Edit Your Story"
              : `🕉 ${t("Update Your Spiritual Story")}`}
          </h2>
          <div className="create-story-form">
            {/* Format */}
            {storyCategory !== "kids" && (
            <div className="create-story-group">
              <label>{t("chooseformat")}</label>
              <div className="create-story-options">
                <button
                  type="button"
                  className={`create-story-option-btn ${
                    format === "write" ? "active" : ""
                  }`}
                  onClick={() => setFormat("write")}
                >
                  ✍ {t("writemystory")}
                </button>
                <button
                  type="button"
                  className={`create-story-option-btn ${
                    format === "record" ? "active" : ""
                  }`}
                  onClick={() => setFormat("record")}
                >
                  🎤 {t("recordmystory")}
                </button>
              </div>
            </div>
            )}

            {storyCategory !== "kids" && (
            <div className="create-story-group hide-name-section">
  <label className="hide-name-label">
   
  {t("hidemyname")}

     <input
      type="checkbox"
      checked={hideName}
      className="hide-name-label"
      onChange={(e) => setHideName(e.target.checked)}
    />
  </label>
</div>
            )}

            {/* Language */}
            <div className="create-story-group">
              <label>{t("language")}</label>
              <select
                value={language}
                onChange={handleLanguageChange}
                className="create-story-dropdown"
              >
                <option value="en">English</option>
                <option value="hi">हिंदी</option>
                {/* <option value="bn">বাংলা</option>
                <option value="gu">ગુજરાતી</option>
                <option value="ml">മലയാളം</option>
                <option value="mr">मराठी</option>
                <option value="pa">ਪੰਜਾਬੀ</option>
                <option value="kn">ಕನ್ನಡ</option>
                <option value="ta">தமிழ்</option>
                <option value="te">తెలుగు</option> */}
              </select>
            </div>

            {/* Title */}
            <div className="create-story-group">
              <label>{t("title")} *</label>
              <input
                type="text"
                placeholder={t("enterstorytitle") + "..."}
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                  seterrortitlemessage("");
                }}
                className="create-story-input"
                required
              />
              {errortitlemessage ? (
              <p className="register-error-message createstory-error-message">
                {errortitlemessage}
              </p>
            ) : null}
            </div>

            {storyCategory === "kids" && (
              <div className="create-story-group">
                <label>Name *</label>
                <input
                  type="text"
                  placeholder="Enter your name..."
                  maxLength={255}
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    seterrornamemessage("");
                  }}
                  className="create-story-input"
                />
                {errornamemessage && (
                  <p className="register-error-message createstory-error-message">
                    {errornamemessage}
                  </p>
                )}
              </div>
            )}

            {/* Write Mode */}
            {(storyCategory === "kids" || format === "write") && (
              <div className="create-story-group">
                <label>{t("writestory")} *</label>
                <Editor
                  storyEditor
                  value={storyText}
                  onChange={(data) => {
                    setStoryText(data);
                    seterrorstorytext("");
                  }}
                  editorLoaded={editorLoaded}
                />
                {errorstorytext ? (
                  <p className="register-error-message createstory-error-message">
                    {errorstorytext}
                  </p>
                ) : null}

                {storyCategory !== "kids" && (listening ? (
                  <button
                    type="button"
                    onClick={stoospeechtotext}
                    className="create-story-mic-btn active"
                  >
                    🛑 {t("stopspeaking")}
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={startspeechtotext}
                    className="create-story-mic-btn"
                  >
                    🎙 {t("startspeaking")}
                  </button>
                ))}
              </div>
            )}

            {/* Record Mode */}
            {storyCategory !== "kids" && format === "record" && (
              <div className="create-story-group">
                <label>{t("recordaudio")} *</label>
                <div className="create-story-audio-controls">
                  {!recording ? (
                    <button
                      type="button"
                      onClick={startRecording}
                      className="create-story-record-btn"
                    >
                      🎙 {t("startspeaking")}
                    </button>
                  ) : (
                    <button
                      type="button"
                      onClick={stopRecording}
                      className="create-story-stop-btn"
                    >
                      ⏹ {t("stopspeaking")}
                    </button>
                  )}
                  {audioUrl ? (
                  <div className="d-flex">
                    <audio controls src={audioUrl}></audio>
                    <FontAwesomeIcon
                      icon={faTrash}
                      className="removevoicerecordicon"
                      onClick={() => {setAudioUrl(null)}}
                    />
                  </div>
                ) : (
                  <div></div>
                )}
                {errorstoryaudio ? (
                  <p className="register-error-message createstory-error-message">
                    {errorstoryaudio}
                  </p>
                ) : null}
                </div>
              </div>
            )}

            {/* Photo Upload */}
            <div className="create-story-group">
              <label>{t("uploadphotos")}</label>
              <div
                className="create-story-drop-zone"
                onDragOver={handleDragOver}
                onDrop={handleDrop}
                onClick={() => fileInputRef.current?.click()}
              >
                <span className="create-story-upload-icon">📷</span>
                <p>{t("draganddrop")}</p>
                <input
                  ref={fileInputRef}
                  type="file"
                  accept="image/*"
                  onChange={handlePhotoUpload}
                  style={{ display: "none" }}
                />
              </div>

              {/* ✅ Updated — delete existing + new preview */}
              <div className="create-story-photo-preview">
                {photos.length === 0 && existingPhotos.map((file, index) => (
                    <div
                      key={`exist-${index}`}
                      className="create-story-photo-item"
                    >
                      <img
                        src={assetsUrl + "photos/" + file}
                        alt="photo"
                        className="create-story-photo"
                      />
                      <button
                        type="button"
                        className="create-story-photo-delete"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleremoveimage(index);
                        }}
                      >
                        ✕
                      </button>
                    </div>
                ))}

                {photos.map((file, index) => (
                  <div key={`new-${index}`} className="create-story-photo-item">
                    <img
                      src={URL.createObjectURL(file)}
                      alt="preview"
                      className="create-story-photo"
                    />
                    <button
                      type="button"
                      className="create-story-photo-delete"
                      onClick={(e) => {
                        e.stopPropagation();
                        setPhotos(photos.filter((_, i) => i !== index));
                      }}
                    >
                      ✕
                    </button>
                  </div>
                ))}
              </div>
            </div>

            {/* Spiritual Tags */}
            {storyCategory !== "kids" && (
            <div className="create-story-group">
              <label className="create-story-tag-header">
                🕉 {t("tagyourstory")}
              </label>

              <div className="create-story-tag-row">
                <input
                  type="text"
                  className="create-story-dropdown"
                  placeholder={t("Deity")}
                  value={selecteddiety}
                  onChange={(e) => setselecteddiety(e.target.value)}
                />

                <input
                  type="text"
                  className="create-story-dropdown"
                  placeholder={t("Place")}
                  value={selectedplace}
                  onChange={(e) => setselectedplace(e.target.value)}
                />
              </div>
            </div>
            )}

            {/* Submit */}
            <button
              type="submit"
              className="create-story-submit-btn"
              onClick={handleUpdate}
            >
              🌸 {t("updatestory")}
            </button>
          </div>
        </div>
        </div>

        {cropModalOpen && (
  <div className="crop-overlay">
    <div className="crop-modal">

      <div className="crop-header">
        <h3>Crop Image</h3>
        <button onClick={() => setCropModalOpen(false)}>✕</button>
      </div>

      <div className="cropper-container">
        <Cropper
          image={selectedImage}
          crop={crop}
          zoom={zoom}
          aspect={FIXED_ASPECT}
          objectFit="cover"
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={onCropComplete}
        />
      </div>

      <div className="crop-controls">
        <input
          type="range"
          min={1}
          max={3}
          step={0.1}
          value={zoom}
          onChange={(e) => setZoom(e.target.value)}
        />

        <div className="crop-action-buttons">
          <button
            className="cancel-btn"
            onClick={() => setCropModalOpen(false)}
          >
            Cancel
          </button>
          <button
            className="apply-btn"
            onClick={createCroppedImage}
          >
            Apply Crop
          </button>
        </div>
      </div>

    </div>
  </div>
)}
      </div>
    </>
  );
};

export default EditStory;
